import { create } from 'zustand';

interface SessionStore {
    isSessionExpired: boolean;
    setSessionExpired: (value: boolean) => void;
    clearSessionExpired: () => void;
}

export const useSessionStore = create<SessionStore>((set) => ({
    isSessionExpired: false,
    setSessionExpired: (value) => {
        set({ isSessionExpired: value });
        if (value) {
            localStorage.setItem('sessionExpired', 'true');
        } else {
            localStorage.removeItem('sessionExpired');
        }
    },
    clearSessionExpired: () => {
        set({ isSessionExpired: false });
        localStorage.removeItem('sessionExpired');
    }
})); 